export function transformArtworkUrl(response) {
    return response?.artistArtUrl;
}
